import { render } from "./ChipAnimation.vue?vue&type=template&id=5ff27fd4"
import script from "./ChipAnimation.vue?vue&type=script&lang=js"
export * from "./ChipAnimation.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/payments-cmglobals/payments-cmglobals/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__